<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.9082 6.48299V14.5913C1.9082 16.1747 3.0332 16.8247 4.39987 16.0413L6.3582 14.9247C6.7832 14.683 7.49154 14.658 7.9332 14.883L12.3082 17.0747C12.7499 17.2913 13.4582 17.2747 13.8832 17.033L17.4915 14.9663C17.9499 14.6997 18.3332 14.0497 18.3332 13.5163V5.40799C18.3332 3.82465 17.2082 3.17465 15.8415 3.95799L13.8832 5.07465C13.4582 5.31632 12.7499 5.34132 12.3082 5.11632L7.9332 2.93299C7.49154 2.71632 6.7832 2.73299 6.3582 2.97465L2.74987 5.04132C2.2832 5.30799 1.9082 5.95799 1.9082 6.48299Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.1333 3.33594V14.1693"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.1084 5.51562V16.6656"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>